<h1 mat-mdc-dialog-title class="center">Téléchargement du bordereau</h1>
<div mat-dialog-content>
  <p class="text-center">
    Bordereau de mise {{data.type == "MAD" ? "à disposition" : "en place"}} du <strong>{{ data.date | date: 'EEEE': 'fr' | titlecase }} - {{ data.date | date: 'dd/MM/yyyy': 'fr'}}</strong>
  </p>
</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="accept()" cdkFocusInitial color="primary">Télécharger</button>
  <button mat-raised-button (click)="transform()" color="white">Transformer en mise {{data.type == "MAD" ? "en place" : "à disposition"}}</button>
</div>